<template>
    <a v-tooltip.top="tooltipContent" class="dropdown button" :class="classes" @click="activate">
        <span class="dropdown-dots">
            <span></span>
            <span></span>
            <span></span>
        </span>

        <span class="dropdown-body">
            <span class="dropdown-content" :class="containerClass">
                <slot />
            </span>
        </span>
    </a>
</template>

<script>
import dropdownMixin from 'mixins/components/dropdown';

export default {
    mixins: [dropdownMixin],

    computed: {
        classes() {
            let classes = {};

            classes[`is-${this.position}`] = true;
            classes['is-active'] = this.active;
            classes['is-actions'] = this.actions;
            classes['is-disabled'] = this.disabled;

            return classes;
        },
    },
};
</script>
